import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import PageSeo from "../SEO/PageSeo";
import { FaWhatsapp, FaTelegramPlane } from "react-icons/fa";
import { WA_LINK, TG_LINK } from "../../config/contactLinks";
import { useLanguage } from "../../context/LanguageContext";

function Contact() {
  const { t } = useLanguage();
  return (
    <Container fluid className="resume-section" id="contact-page">
      <PageSeo
        title={t("seo.contact.title")}
        description={t("seo.contact.description")}
        breadcrumbItems={[
          { name: t("nav.home"), path: "/" },
          { name: t("nav.contact"), path: "/contact" },
        ]}
      />
      <Particle />
      <Container style={{ paddingTop: "100px", paddingBottom: "80px" }}>
        <Row className="justify-content-center">
          <Col md={8} lg={7}>
            <h1 className="project-heading text-center mb-2">
              {t("contact.h1a")}
              <strong className="purple">{t("contact.h1b")}</strong>
            </h1>
            <p className="text-center text-white-50 mb-4">{t("contact.intro")}</p>
            <div className="d-flex flex-wrap gap-3 justify-content-center mb-4">
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary btn-lg d-inline-flex align-items-center gap-2"
              >
                <FaWhatsapp size={22} /> WhatsApp
              </a>
              <a
                href={TG_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline-light btn-lg d-inline-flex align-items-center gap-2"
              >
                <FaTelegramPlane size={22} /> Telegram
              </a>
            </div>
            <p className="text-center text-white-50 small mb-0">
              {t("footer.tagline")}
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Contact;
